import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import { breakpointValues, mediaQuery } from '@modernhealth/vital-foundation';
import Carousel from 'react-slick';
import { pxToRem } from '../../helpers/pxToRem';
import iconArrowBack from './assets/icon-arrow-back.svg';
import iconArrowForward from './assets/icon-arrow-forward.svg';
import * as styles from './ContentCardsRow.module.scss';
import { ContentCard, ContentCardSkeleton, } from './ContentCard';
const Name = 'ContentCardsRow';
export const ContentCardsRow = ({ items, cardTestID = 'ContentCard', }) => {
    return (_jsx(Carousel, { ...sliderSettings, className: styles.carousel, "data-component": Name, children: items.map((item, i) => (_jsx(CarouselItem, { children: _createElement(ContentCard, { ...item, key: item.id, testID: cardTestID + i }) }, `slide_${item.title}`))) }));
};
export const ContentCardsRowSkeleton = ({ items }) => {
    return (_jsx(Carousel, { ...sliderSettings, className: styles.carousel, arrows: false, children: items.map((_, i) => (_jsx(CarouselItem, { children: _jsx(ContentCardSkeleton, {}) }, `slide_skeleton_${i}`))) }));
};
const CarouselButton = ({ onClick, className = '', prevButton, }) => {
    const xPosField = prevButton ? 'left' : 'right';
    const image = prevButton ? iconArrowBack : iconArrowForward;
    const opacity = className.includes('disabled') ? 0 : 1;
    return (_jsx(CarouselArrowImage, { xPosField: xPosField, opacity: opacity, src: image, onClick: onClick }));
};
const CarouselItem = styled('div')({
    '&&': {
        display: 'flex',
        cursor: 'pointer',
        height: 'auto',
        '&:not(:first-of-type)': {
            marginLeft: pxToRem(16),
        },
    },
});
const CarouselArrowImage = styled.img(({ opacity, xPosField }) => ({
    height: pxToRem(32),
    width: pxToRem(32),
    position: 'absolute',
    top: pxToRem(40),
    cursor: 'pointer',
    [xPosField]: pxToRem(-45),
    opacity,
    [mediaQuery.maxWidth('xl')]: {
        top: pxToRem(24),
    },
}));
const sliderSettings = {
    infinite: false,
    speed: 500,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 3,
    nextArrow: _jsx(CarouselButton, {}),
    prevArrow: _jsx(CarouselButton, { prevButton: true }),
    responsive: [
        {
            breakpoint: breakpointValues.md,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
            },
        },
        {
            breakpoint: breakpointValues.xl,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
            },
        },
    ],
};
